export const BANNER_TYPE = {
    DEFAULT: 'default',
    SUCCESS: 'success',
    WARNING: 'warning',
    NOTICE: 'notice',
};
